module.exports = __webpack_public_path__ + "media/sparks_looping.25ddba54.mp4";